import axios from "axios";

export const useOrderRequests = () => {
  const getBankAccounts = async () => {
    return axios({
      method: "get",
      url: `${
        process.env.REACT_APP_API + process.env.REACT_APP_GET_BANK_ACCOUNTS
      }`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_GET_BANK_ACCOUNTS
        }`,
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };
  const getOrders = async () => {
    return axios({
      method: "get",
      url: `${process.env.REACT_APP_API + process.env.REACT_APP_ORDERS}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_ORDERS
        }`,
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };

  const getCollections = async () => {
    return axios({
      method: "get",
      url: `${process.env.REACT_APP_API + process.env.REACT_APP_COLLECTIONS}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_COLLECTIONS
        }`,
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };

  const getCollection = async (id) => {
    return axios({
      method: "get",
      url:
        `${
          process.env.REACT_APP_API + process.env.REACT_APP_COLLECTION
        }?collectionId=` + id,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_COLLECTION
        }`,
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };

  const getInvoices = async () => {
    return axios({
      method: "get",
      url: `${process.env.REACT_APP_API + process.env.REACT_APP_GET_INVOICES}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_GET_INVOICES
        }`,
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };

  const getInvoice = async (id) => {
    return axios({
      method: "get",
      url: `${
        process.env.REACT_APP_API + process.env.REACT_APP_GET_INVOICE
      }?invoiceId=${id}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_GET_INVOICE
        }`,
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };

  const getOrder = async (id) => {
    return axios({
      method: "get",
      url: `${
        process.env.REACT_APP_API + process.env.REACT_APP_ORDER
      }?orderId=${id}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_ORDERS
        }`,
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };

  const createOrder = async (order) => {
    return axios({
      method: "post",
      url: `${process.env.REACT_APP_API + process.env.REACT_APP_CREATE_ORDER}`,
      data: order,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_CRAETE_ORDERS
        }`,
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };

  const cancelOrder = async (id) => {
    return axios({
      method: "post",
      url: `${
        process.env.REACT_APP_API + process.env.REACT_APP_CANCEL_ORDER
      }?orderId=${id}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_CANCEL_ORDER
        }`,
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };

  const getProductReports = async (startDate, endDate) => {
    return axios({
      method: "get",
      url: `${
        process.env.REACT_APP_API + process.env.REACT_APP_PRODUCT_REPORTS
      }?FirstDate=${startDate}&LastDate=${endDate}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_PRODUCT_REPORTS
        }`,
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };

  const createPaymentForm = async (data = { type: 1, amount: 1 }) => {
    return axios({
      method: "post",
      url: `${process.env.REACT_APP_API + process.env.REACT_APP_GET_PAYMENT}`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_PRODUCT_REPORTS
        }`,
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };

  return {
    getBankAccounts,
    getOrders,
    getOrder,
    createOrder,
    getCollections,
    getCollection,
    getProductReports,
    createPaymentForm,
    getInvoices,
    getInvoice,
    cancelOrder,
  };
};
